import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const HelpSvg = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" width="40" height="40">
        <path fill="currentColor"
            d="M10 21.5a11.5 11.5 0 1 1 23 0 11.5 11.5 0 0 1-23 0ZM21.5 9a12.5 12.5 0 1 0 0 25 12.5 12.5 0 0 0 0-25ZM18 17c0-.87.32-1.6.9-2.13a3.78 3.78 0 0 1 2.6-.87c2.32 0 3.5 1.37 3.5 2.5 0 1.23-.8 1.96-1.8 2.7l-.27.2c-.4.3-.83.61-1.16.95-.42.42-.77.95-.77 1.65v2h1v-2c0-.32.15-.62.48-.95.27-.27.62-.52 1.01-.81l.3-.23c1-.74 2.21-1.74 2.21-3.51 0-1.87-1.82-3.5-4.5-3.5-1.35 0-2.48.4-3.27 1.13A3.8 3.8 0 0 0 17 17h1Zm4.5 11c0 .55-.46 1-1 1s-1-.45-1-1 .46-1 1-1 1 .45 1 1Zm-1 2c1.08 0 2-.9 2-2s-.92-2-2-2-2 .9-2 2 .92 2 2 2Z"></path>
    </svg>
)

const Help: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {HelpSvg}
    </SvgIcon>
)

export default Help